// 3rd party imports
import * as React from 'react';

// bernie
import { DialogRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

// shared-ui
import { ILocalization, LocalizedText } from '@shared-ui/localization-context';

// ui
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkList, UitkListItem } from 'uitk-react-list';
import { UitkLink } from 'uitk-react-link';

// util
import { modifyLocaleParam } from '../../util/LocaleParamTransformer';
import { Program } from 'models';
import { Redirect } from 'react-router';
import { useHistory } from 'react-router-dom';

export interface JoinAffiliateNetworkDialogProps {
  dialogId: string;
  l10n?: ILocalization;
  routeStore: RouteStore;
  locale: string;
  program: Program;
  isPreviewMode?: boolean;
  showManageProgramLink?: boolean;
}

export const JoinAffiliateNetworkDialog: React.FunctionComponent<JoinAffiliateNetworkDialogProps> = ({
  dialogId,
  l10n,
  routeStore,
  locale,
  program,
  isPreviewMode,
  showManageProgramLink,
}) => {
  const onDismiss = () => {
    routeStore.closeDialog();
  };

  const signUpLink = program.signUpLink?.replace(':localeName', modifyLocaleParam(locale));

  const history = useHistory();
  const handleJoinAffiliateNetwork = () => {
    if (program.network === 'PARTNERIZE') {
      history.push(signUpLink);
    } else {
      window.open(signUpLink);
    }
  };

  const manageProgramsLink = ['', modifyLocaleParam(locale), 'programs'].join('/');

  const network = program.network.toLowerCase();

  let dialogHeading = `join.program.${network}.title`;
  const dialogCtaText = l10n.formatText(`join.program.${network}.route.msg`);
  // let dialogContinueText = l10n.formatText('join.')

  let previewDialogFirstParagraph;
  let manageProgramLinkContent;

  if (isPreviewMode) {
    dialogHeading = 'preview.products.dialog.heading';
    previewDialogFirstParagraph = (
      <UitkText spacing="two">
        <LocalizedText message="preview.products.dialog.instruct.1" />
      </UitkText>
    );
  }

  if (showManageProgramLink) {
    manageProgramLinkContent = (
      <UitkText spacing="two">
        <LocalizedText message={`preview.products.join.${network}.modal.instruct.5`} />
        <UitkText inline={true}>
          <LocalizedText message={`join_affiliate_network.dialog.${network}.have_network_account_add_it_from`} />
          &nbsp;
        </UitkText>
        <UitkLink inline={true}>
          <a href={manageProgramsLink}>
            <LocalizedText message="lp.manage.action.text" />
          </a>
        </UitkLink>
      </UitkText>
    );
  }

  const cjDialogText = () => {
    return (
      <>
        <UitkText spacing="two">
          <LocalizedText message={'join.program.cj.instruct.1'} />
        </UitkText>
        <UitkText spacing="two">
          <LocalizedText message={'join.program.cj.instruct.2'} />
        </UitkText>
        <UitkText spacing="two">
          <LocalizedText message={'join.program.cj.instruct.3'} />
          <UitkSpacing padding={{ block: 'three', inline: 'four' }}>
            <UitkList>
              <UitkListItem key="listitem-1-1">
                <UitkText size={400}>
                  <LocalizedText message={'join.program.cj.instruct.4'} />
                </UitkText>
              </UitkListItem>
              <UitkListItem key="listitem-1-2">
                <UitkText size={400}>
                  <LocalizedText message={'join.program.cj.instruct.5'} />
                </UitkText>
              </UitkListItem>
            </UitkList>
          </UitkSpacing>
        </UitkText>
      </>
    );
  };

  const pzDialogText = () => {
    return (
      <>
        <UitkText spacing="two">
          <LocalizedText message={'join.program.partnerize.instruct.1'} />
        </UitkText>
        <UitkText spacing="two">
          <LocalizedText message={'join.program.partnerize.instruct.2'} />
        </UitkText>
      </>
    );
  };

  let dialogText = null;
  switch (network) {
    case 'cj':
      dialogText = cjDialogText();
      break;
    case 'partnerize':
      dialogText = ''; //pzDialogText();
      break;
  }

  const dialogContent = (
    <UitkDialogContent>
      <UitkHeading tag="h3" size={5}>
        <LocalizedText message={dialogHeading} />
      </UitkHeading>
      <UitkSpacing margin={{ blockstart: 'six' }}>
        <div>
          {previewDialogFirstParagraph}
          {dialogText}
          {manageProgramLinkContent}
        </div>
      </UitkSpacing>
    </UitkDialogContent>
  );

  return (
    <>
      <DialogRoute id={dialogId}>
        <Layer id="dialogJoinAffiliateNetwork" onDismiss={onDismiss}>
          <UitkDialog returnFocusOnClose={true}>
            {dialogContent}
            <UitkDialogFooter
              key="UitkDialogFooter"
              stacked={true}
              buttonOne={{
                onClick: handleJoinAffiliateNetwork,
                text: dialogCtaText,
                type: 'primary',
              }}
              buttonTwo={{
                onClick: onDismiss,
                text: l10n.formatText('preview.products.dialog.continue'),
                type: 'tertiary',
              }}
            />
          </UitkDialog>
        </Layer>
      </DialogRoute>
    </>
  );
};
